<template>
  <div class="login" :style="`background: url(${mainBg}) center center/cover no-repeat`">
    <div class="header">
      <img :src="logoUrl" class="header-logo" />
      <span class="header-title">{{ title }}</span>
    </div>
    <div class="wrapper">
      <div class="wrapper-top">
        <p class="title">{{ title }}</p>
        <p class="subtitle">欢迎进入大数据服务平台!</p>
      </div>
      <div class="wrapper-bottom">
        <el-form ref="loginForm" :model="loginForm" :rules="rules">
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号" size="middle" maxlength="11"
                      @keyup.native="loginForm.phoneNumber = loginForm.phoneNumber.replace(/[^\d]/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="userPassword">
            <el-input v-model="loginForm.userPassword" placeholder="请输入密码" type="password" size="middle" @keyup.enter.native="handleLogin"></el-input>
          </el-form-item>
        </el-form>
        <span class="forget" @click="handleDialog">忘记密码?</span>
        <el-button class="btn-login" :loading="btnLoading" @click="handleLogin">登录</el-button>
      </div>
    </div>
    <PasswdFind v-if="showDialog" :title="title" @close="handleClose"></PasswdFind>
  </div>
</template>

<script>
import PasswdFind from './passwdFind.vue'
import {
  loginApi,
  getSystemInfoApi,
  checkLoginApi,
} from './fetch'
export default {
  name: 'Login',
  components: {
    PasswdFind,
  },
  data () {
    // 手机号校验
    const validPhone = (rules, value, callback) => {
      if (!value) callback()
      if (/^1\d{10}$/g.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确手机号'))
      }
    }

    return {
      loading: false,
      btnLoading: false,
      logoUrl: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/default-logo.png',
      mainBg: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/login-bg.png',
      title: '大数据服务平台',
      loginForm: {
        phoneNumber: '',
        userPassword: '',
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          { validator: validPhone, trigger: ['change', 'blur'] },
        ],
        userPassword: [
          { required: true, message: '请输入密码', trigger: ['change', 'blur'] },
        ],
      },
      showDialog: false,
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.loading = true
        const res = await getSystemInfoApi()
        res.systemName ? this.title = res.systemName : this.title = '大数据服务平台'
        res.systemLogo ? this.logoUrl = res.systemLogo : this.logoUrl = 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/default-logo.png'
        res.systemLoginBackground ? this.mainBg = res.systemLoginBackground : this.mainBg = 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/login-bg.png'

        // 用户登录状态下进入登录页, 回到首页
        const isLogin = await checkLoginApi()
        if (isLogin) {
          this.$router.push({ path: '/home' })
          return
        }
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    async handleLogin () {
      try {
        await this.$refs.loginForm.validate()
        this.btnLoading = true
        await loginApi({
          ...this.loginForm,
          // systemDomain: 'dev',
        })
        this.$success('登录成功')
        window.location.href = '/'
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
    handleDialog () {
      this.showDialog = true
    },
    handleClose () {
      this.showDialog = false
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate()
      })
    },
  },
}
</script>

<style lang='scss' scoped>
  .login{
    position: relative;
    padding: 30px 0 0 40px;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    .header {
      height: 32px;
      line-height: 32px;
      display: flex;
      align-items: center;
      &-logo {
        margin-right: 5px;
        height: 32px;
        object-fit: cover;
        vertical-align: middle;
        border-radius: 2px;
      }
      &-title {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
      }

    }
    .wrapper{
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 1080px;
      height: 388px;
      left: 85%;
      top: 35%;
      transform: translate(-45%,-50%);
      &-top {
        color: #fff;
        margin-bottom: 60px;
        .title {
          font-size: 48px;
          font-weight: bold;
          line-height: 48px;
          margin-bottom: 30px;
        }
        .subtitle {
          font-size: 26px;
          line-height: 26px;
        }
      }
      &-bottom {
        padding: 60px 100px;
        width: 560px;
        height: 100%;
        background-color: #fff;
        border-radius: 8px;
        .forget {
          margin-top:-15px;
          float: right;
          color: #C4C4C4;
          cursor: pointer;
          &:hover {
            color:#3269FF;
          }

        }
        .btn-login {
          margin-top: 30px;
          width: 360px;
          height: 46px;
          font-size: 16px;
          background: #3269FF;
          color: #fff;
          border-radius: 2px;
          text-align:center;
          border: none;
          cursor: pointer;
          border-style: none;

        }
      }

    }

    ::v-deep .el-input__inner {
      height: 46px;
      line-height: 46px;
      border-radius: 2px;
      border: 1px solid #E8E8E8 ;

    }
  }
</style>
